import type { LucideIcon } from 'lucide-react'
import { ChevronRight } from 'lucide-react'
import { Body } from '@meiuca/ui-components'

interface ExploreCategoryCardProps {
  icon: LucideIcon
  title: string
  description: string
  onClick: () => void
}

export function ExploreCategoryCard({ icon: Icon, title, description, onClick }: ExploreCategoryCardProps) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-4 w-full p-4 bg-background-white rounded-2xl border border-border-light hover:border-brand-primary/40 hover:shadow-sm transition-all text-left"
    >
      <div className="w-14 h-14 rounded-xl bg-brand-primary/10 flex items-center justify-center flex-shrink-0">
        <Icon className="w-7 h-7 text-brand-primary" />
      </div>

      <div className="flex-1 min-w-0">
        <Body className="font-semibold text-text-primary">{title}</Body>
        <Body className="text-sm text-text-secondary">{description}</Body>
      </div>

      <ChevronRight className="w-4 h-4 text-text-tertiary flex-shrink-0" />
    </button>
  )
}
